function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-content-container'>
        <div className='container footer-content'>
          <div className='section-1-container footer-section'>
            <a
              href='https://www.comporium.com/?_gl=1*1qp0nzp*_gcl_au*MjAwODI1NTM0Mi4xNzA3MTY4MTM1&amp;_ga=2.268141006.118943165.1707168134-1763873758.1707168134'
              target='_blank'
              rel='noreferrer'>
              <img
                src='https://www.comporium.com/wp-content/uploads/2020/07/comporium-logo.png'
                className='shop-footer-image'
                alt='Comporium'
              />
            </a>
            <p className='footer-service-copy'>
              Serving areas in SC and NC surrounding the cities of Fort Mill, Rock Hill, Lancaster, Lexington, Tega Cay, Indian Land,
              Charlotte, and Brevard
            </p>
            <p className='footer-service-copy'>
              Comporium, Inc. <br />
              P.O. Box 470 | Rock Hill, SC | 29731
              <br />
              330 East Black Street | Rock Hill, SC | 29730
            </p>
          </div>
          <div className='section-2-container footer-section'>
            <ul>
              <li>
                <a href='https://www.comporium.com/terms-and-conditions/' target='_blank' rel='noreferrer'>
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/service-agreements/' target='_blank' rel='noreferrer'>
                  Service Agreements
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/privacy-policy/' target='_blank' rel='noreferrer'>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href='https://labels.comporium.com/' target='_blank' rel='noreferrer'>
                  FCC Broadband Labels
                </a>
              </li>
            </ul>
          </div>
          <div className='section-3-container footer-section'>
            <ul>
              <li>
                <a href='https://www.comporium.com/linking-policy/' target='_blank' rel='noreferrer'>
                  Linking Policy
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/acceptable-use-policy/' target='_blank' rel='noreferrer'>
                  Internet Acceptable Use Policy
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/sitemap/' target='_blank' rel='noreferrer'>
                  Sitemap
                </a>
              </li>
            </ul>
          </div>
          <div className='section-4-container footer-section'>
            <ul>
              <li>
                <a href='https://www.comporium.com/find-a-retail-location/' target='_blank' rel='noreferrer'>
                  Find a Retail Location
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/support/' target='_blank' rel='noreferrer'>
                  Customer Support
                </a>
              </li>
              <li>
                <a href='https://www.comporium.com/careers/' target='_blank' rel='noreferrer'>
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div className='section-5-container footer-section'>
            <div>
              <p>
                Follow us on&nbsp;
                <a href='https://www.facebook.com/Comporium' target='_blank' rel='noreferrer'>
                  Facebook
                </a>
                ,&nbsp;
                <a href='https://twitter.com/comporium' target='_blank' rel='noreferrer'>
                  Twitter
                </a>
                ,&nbsp;
                <a href='https://www.instagram.com/comporiuminc/' target='_blank' rel='noreferrer'>
                  Instagram
                </a>
                , or&nbsp;
                <a href='https://www.linkedin.com/company/comporium-communications' target='_blank' rel='noreferrer'>
                  LinkedIn&nbsp;
                </a>
                to receive updates regarding our latest products and services.
              </p>
            </div>
            <ul className='footer-social-icons'>
              <li>
                <a href='https://www.facebook.com/Comporium' target='_blank' rel='noreferrer'>
                  <i className='fa-brands fa-facebook-f'></i>
                </a>
              </li>
              <li>
                <a href='https://twitter.com/comporium' target='_blank' rel='noreferrer'>
                  <i className='fa-brands fa-x-twitter'></i>
                </a>
              </li>
              <li>
                <a href='https://www.linkedin.com/company/comporium-communications' target='_blank' rel='noreferrer'>
                  <i className='fa-brands fa-linkedin'></i>
                </a>
              </li>
              <li>
                <a href='https://www.youtube.com/user/comporium' target='_blank' rel='noreferrer'>
                  <i className='fa-brands fa-youtube'></i>
                </a>
              </li>
              <li>
                <a href='https://www.instagram.com/comporiuminc/' target='_blank' rel='noreferrer'>
                  <i className='fa-brands fa-instagram'></i>
                </a>
              </li>
            </ul>
            <div>
              <p>&copy; Comporium, Inc. {new Date().getFullYear()} All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
